import HttpClient from "../httpClient";
import {
    WaterMonitoringChartResponse,
    WaterMonitoringChartRequest,
    WaterMonitoringResponse,
} from "../../models/types/waterMonitoring";

class WaterMonitoringService {
    private service = HttpClient;

    async getWaterMonitoringForChart(requestData: WaterMonitoringChartRequest): Promise<WaterMonitoringChartResponse> {
        const response = await this.service.get<WaterMonitoringChartResponse>("/admin/Dashboard/GetWaterMonitoringForChart", requestData, {
            withCredentials: true,
            headers: {
                'X-TenantId': 1
            }
        });
        return response;
    }

    async getCurrentWaterMonitoring(): Promise<WaterMonitoringResponse> {
        const response = await this.service.get<WaterMonitoringResponse>("/admin/Dashboard/GetCurrentWaterMonitoring", {}, {
            withCredentials: true,
            headers: {
                'X-TenantId': 1
            }
        });
        return response;
    }

}

const waterMonitoringSvc = new WaterMonitoringService();
export default waterMonitoringSvc;
